module.exports = __webpack_public_path__ + "media/images/radar_icon-8f02550c8c3216f56218ccabf9170515.png";